// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";

import { useMemo } from "@mairistem/tools";

import { FavoriteService } from "../services";

import { DataProvider } from "../../libs/components/DataProvider";

export const FavoriteDomainDataProvider = (props) => {
	const { children, domain } = props;

	const [favorites, loading, fetching] =
		FavoriteService.queryFavoritesByDomain(domain);

	return useMemo(
		() => (
			<DataProvider data={favorites} loading={loading} fetching={fetching}>
				{children}
			</DataProvider>
		),
		[children, loading, fetching, favorites],
	);
};
